let id = 1;
export function generateUniqueDomId(prefix = 'element') {
  return `${prefix}-${id++}`;
}
